
import axios from "axios"
import { Api_url } from "../../common/api_url"
import { API_XANO_AUTH_URL, API_XANO_BASE_URL, API_XANO_SEARCH_BASE_URL, MOBILE_OTP_AUTH_KEY, MOBILE_OTP_AUTH_TEMPLATE_ID, API_XANO_AUTH_FACEBOOK_URL, API_XANO_UTM_URL, API_XANO_AUTH_BASE_URL} from "../../config/api_config"
import { axiosAuth, axiosNoAuth } from "../../config/axiosInstances";
import { LOGOUT_REQUEST, SET_EXPIRATION_TOKEN, SET_MOBILE_NUMBER, SET_ONBOARDING_DATA, SET_PROFILE_DETAILS, SET_TOKEN, SET_USER_ACTIVITY, SET_USER_EXTENDED_CHALLENGES, SET_USER_ONE_DAY_TIMER } from "./types"
//import { API_XANO_AUTH_SERVICE_BASE_URL, API_XANO_VERIFICATION_BASE_URL } from "../../config/api_config"
// import { getEpsFormData } from "./jobEligibilityScore"
// import { LOGOUT_REQUEST, SET_EXPIRATION_TOKEN, SET_MOBILE_NUMBER, SET_PROFILE_DETAILS, SET_TOKEN, SET_USER_ACTIVITY, SET_USER_EXTENDED_CHALLENGES } from "./types"
// import { setEpsData } from "./userActivity"
const jose = require('jose');
const API_XANO_AUTH_SERVICE_BASE_URL = 'https://xgfy-czuw-092q.m2.xano.io/api:auth-service';
const API_XANO_VERIFICATION_BASE_URL = 'https://xgfy-czuw-092q.m2.xano.io/api:verification-service:v1'

export function xanoUserSignup(formData, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.post(API_XANO_AUTH_SERVICE_BASE_URL + Api_url.AuthService, {
                signup_type: 'email',
                name: formData?.name,
                email: formData?.email,
                phone_number: formData?.phone,
                password: formData?.password,
                signup_medium: 'webapp',
                campaign: '',
                is_login: false,
                signup_page_url : localStorage?.getItem("savedLandingPageURL")
            })
            if(response?.data?.result === 'success'){
            dispatch({ type: SET_TOKEN, payload: response.data.authToken })
            
            const profileDetails = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetProfileDetails, {
                headers: {
                    Authorization: `Bearer ${response.data.authToken}`
                }
            })

            dispatch({ type: SET_PROFILE_DETAILS, payload: { ...profileDetails.data } })
            dispatch({ type: SET_USER_ONE_DAY_TIMER , payload : Date.now() + (1*60*60*1000)})

            


            const userActivity = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetUserActivity, {
                params: {
                    user_id: profileDetails.data.id
                }
            })

            dispatch({ type: SET_USER_ACTIVITY, payload: userActivity.data })

            successCallback && successCallback(profileDetails.data)
        }
        else{
            successCallback && successCallback({ number_verification : false , show_toast : true , message : response?.data?.message , result : response?.data?.result });
        }

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err?.response?.data)
        }
    }
}

export function getXanoAuthToken(tokenID, successCallback, errorCallback, sendMessage) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.post(API_XANO_AUTH_SERVICE_BASE_URL + Api_url.AuthService,{
                    signup_type: 'social_google_access_token',
                    access_token: tokenID,
                    signup_medium: 'webapp',
                    campaign : '',
                    is_login : true,
                    signup_page_url : localStorage?.getItem("savedLandingPageURL")
                
            })

            if(response?.data?.result === 'success'){
            dispatch({ type: SET_TOKEN, payload: response.data.authToken })
            

            const profileDetails = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetProfileDetails, {
                headers: {
                    Authorization: `Bearer ${response.data.authToken}`
                }
            })

            dispatch({ type: SET_PROFILE_DETAILS, payload: { ...profileDetails.data } })
            dispatch({ type: SET_USER_ONE_DAY_TIMER , payload : Date.now() + (1*60*60*1000)})


            const userActivity = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetUserActivity, {
                params: {
                    user_id: profileDetails.data.id
                }
            })

            dispatch({ type: SET_USER_ACTIVITY, payload: userActivity.data })

            const challengesMetadata = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetExtendedChallenges, {
                params: {
                    user_id: profileDetails?.data?.id
                }
            })

            // console.log({ challengesMetadata })

            dispatch({ type: SET_USER_EXTENDED_CHALLENGES, payload: challengesMetadata.data })

            sendMessage && sendMessage({
                XanoToken: response.data.authToken,
                userData: profileDetails.data,
                userActivity: userActivity.data
            })
            successCallback && successCallback(profileDetails.data);
         }
            else{
                successCallback && successCallback({ number_verification : false , show_toast : true , message : response?.data?.message , result : response?.data?.result });
            }

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getXanoAuthTokenFromUrl(signup_type,token, successCallback, errorCallback, sendMessage) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.post(API_XANO_AUTH_SERVICE_BASE_URL+ Api_url.AuthService, {
              

                signup_type,
                access_token: token,
                signup_medium: 'webapp',
                is_login: true,
                signup_page_url : localStorage?.getItem("savedLandingPageURL")
                
            })

            
            if(response?.data?.result === 'success'){
            dispatch({ type: SET_TOKEN, payload: response.data.authToken })

            const authData = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetProfileDetails,{
                headers: {
                    Authorization: `Bearer ${response.data.authToken}`
                }
            })

            dispatch({ type: SET_PROFILE_DETAILS, payload: { ...authData.data } })
            dispatch({ type: SET_USER_ONE_DAY_TIMER , payload : Date.now() + (1*60*60*1000)})

            const userActivity = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetUserActivity, {
                params: {
                    user_id: authData.data.id
                }
            })

            dispatch({ type: SET_USER_ACTIVITY, payload: userActivity.data })
            // sendMessage && sendMessage({
            //     XanoToken: authData.data.authToken,
            //     userData: authData.data.profile_details,
            //     userActivity: authData.data.activity
            // })

            successCallback && successCallback(authData.data)
        }
        else{
            successCallback && successCallback({ number_verification : false , show_toast : true , message : response?.data?.message});
        }

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getXanoAuthFacebookToken(tokenID, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosNoAuth.post(API_XANO_AUTH_SERVICE_BASE_URL + Api_url.AuthService, 
               {
                    signup_type: 'social_facebook_access_token',
                    access_token: tokenID,
                    signup_medium: 'webapp',
                    campaign: '',
                    is_login: true,
                    signup_page_url : localStorage?.getItem("savedLandingPageURL")
                }
            )
            //console.log(response);
            if(response?.data?.result === 'success'){
            dispatch({ type: SET_TOKEN, payload: response.data.authToken })

            const profileDetails = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetProfileDetails, {
                headers: {
                    Authorization: `Bearer ${response.data.authToken}`
                }
            })

            dispatch({ type: SET_PROFILE_DETAILS, payload: { ...profileDetails.data } })
            dispatch({ type: SET_USER_ONE_DAY_TIMER , payload : Date.now() + (1*60*60*1000)})


            const userActivity = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetUserActivity, {
                params: {
                    user_id: profileDetails.data.id
                }
            })

            dispatch({ type: SET_USER_ACTIVITY, payload: userActivity.data })

            const challengesMetadata = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetExtendedChallenges, {
                params: {
                    user_id: profileDetails?.data?.id
                }
            })

            dispatch({ type: SET_USER_EXTENDED_CHALLENGES, payload: challengesMetadata.data })

            successCallback && successCallback(profileDetails.data);
        }
        else{
            successCallback && successCallback({ number_verification : false , show_toast : true , message : response?.data?.message});
        }

        }
        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err)
        }

    }
}
export function getXanoAuthEmailToken(email, password, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            //console.log(email,password);
            const response = await axiosAuth.post(API_XANO_AUTH_SERVICE_BASE_URL + Api_url.AuthService, {
                signup_type: 'email',
                email: email,
                password: password,
                signup_medium: 'webapp',
                is_login: true,
                signup_page_url : localStorage?.getItem("savedLandingPageURL")
            })
            //console.log(response);
            if(response?.data?.result === 'success'){
            dispatch({ type: SET_TOKEN, payload: response.data.authToken })

            const profileDetails = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetProfileDetails, {
                headers: {
                    Authorization: `Bearer ${response.data.authToken}`
                }
            })

            dispatch({ type: SET_PROFILE_DETAILS, payload: { ...profileDetails.data } })
            dispatch({ type: SET_USER_ONE_DAY_TIMER , payload : Date.now() + (1*60*60*1000)})


            const userActivity = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetUserActivity, {
                params: {
                    user_id: profileDetails.data.id
                }
            })

            dispatch({ type: SET_USER_ACTIVITY, payload: userActivity.data })

            const challengesMetadata = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetExtendedChallenges, {
                params: {
                    user_id: profileDetails?.data?.id
                }
            })

            dispatch({ type: SET_USER_EXTENDED_CHALLENGES, payload: challengesMetadata.data })

            successCallback && successCallback(profileDetails.data)}
            else{
                successCallback && successCallback({ number_verification : false , show_toast : true , message : response?.data?.message , result : response?.data?.result});
            }
        }
        catch (err) {
            console.log({err});
            errorCallback && errorCallback(err)
        }

    }
}

export function getXanoAuthLinkedInToken(code, redirect_uri, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosNoAuth.post(API_XANO_AUTH_SERVICE_BASE_URL + Api_url.AuthService, 
               {
                    signup_type: 'social_linkedin',
                    access_token: "",
                    signup_medium: 'webapp',
                    campaign: '',
                    is_login: true,
                    code: code,
                    redirect_uri: redirect_uri,
                    signup_page_url : localStorage?.getItem("savedLandingPageURL")
                }
            )
            //console.log(response);
            if(response?.data?.result === 'success'){
            dispatch({ type: SET_TOKEN, payload: response.data.authToken })

            const profileDetails = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetProfileDetails, {
                headers: {
                    Authorization: `Bearer ${response.data.authToken}`
                }
            })

            dispatch({ type: SET_PROFILE_DETAILS, payload: { ...profileDetails.data } })
            dispatch({ type: SET_USER_ONE_DAY_TIMER , payload : Date.now() + (1*60*60*1000)})


            const userActivity = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetUserActivity, {
                params: {
                    user_id: profileDetails.data.id
                }
            })

            dispatch({ type: SET_USER_ACTIVITY, payload: userActivity.data })

            const challengesMetadata = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetExtendedChallenges, {
                params: {
                    user_id: profileDetails?.data?.id
                }
            })

            dispatch({ type: SET_USER_EXTENDED_CHALLENGES, payload: challengesMetadata.data })

            successCallback && successCallback(profileDetails.data);
        }
        else{
            successCallback && successCallback({ number_verification : false , show_toast : true , message : response?.data?.message});
        }

        }
        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err)
        }

    }
}


export function getUserDetails(token) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.get(API_XANO_SEARCH_BASE_URL + Api_url.GetUserDetails, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })

            // console.log(response)

        } catch (err) {
            console.log(err)
        }
    }
}

export function logout() {
    return async function (dispatch) {
        try {
            dispatch({ type: LOGOUT_REQUEST })

        } catch (err) {
            console.log(err)
        }
    }
}

export function sendOtp(phoneNumber, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_AUTH_BASE_URL + Api_url.SendOtpToMobile, {
                mobile: phoneNumber
            }
            )
            // console.log('gg' + response.data);

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }

}

export function verifyOtp(otp, phoneNumber, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_AUTH_BASE_URL + Api_url.VerifyOtp, {
                otp: otp,
                mobile: phoneNumber
            })

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }

}

export function validatePasswordResetAccess(reset_token, otp, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post('https://xgfy-czuw-092q.m2.xano.io/api:password-reset/validate', {
                reset_token,
                otp,
            })

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }

}

export function resendOtp(mobile, type, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_AUTH_BASE_URL + Api_url.ResendOtp, {
                mobile,
                type
            })

            successCallback && successCallback(response.data)
        } catch (err) {

            console.log(err)
        }
    }
}

export function requestResendOtp(email, phone_number, reset_method, resend_type, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:password-reset/resend_otp',
            { 
                params: {
                email,
                phone_number,
                reset_method,
                resend_type
            }
        })

            successCallback && successCallback(response.data)
        } catch (err) {

            console.log(err)
        }
    }
}

export function setOnboardingData(skill_id,  timeslot , learning_goal , employment_status , is_onboarding , is_custom_skill, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.SetOnboardingData, {
                skill_id,
                timeslot,
                learning_goal,
                employment_status,
                is_onboarding,
                is_custom_skill
            })
            dispatch({ type: SET_ONBOARDING_DATA, payload: response.data?.data })
            successCallback && successCallback(response?.data)
        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function setOnboardingPhase(successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.post('https://xgfy-czuw-092q.m2.xano.io/api:HYL0rVog/onboarding/mark_onboarded', {
            })
            successCallback && successCallback(response?.data)
        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}


export function resetPassword(jwt, newPassword, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosNoAuth.post(API_XANO_BASE_URL + Api_url.GetXanoAuthPassWordResetToken, {
                resetToken: jwt
            })
            console.log(response.data.authToken);
            //console.log(jwt , newPassword);

            dispatch({ type: SET_TOKEN, payload: response.data.authToken })

            const resetResponse = await axiosAuth.post(API_XANO_BASE_URL + Api_url.ResetPassword,
                {
                    headers: {
                        Authorization: `Bearer ${response.data.authToken}`
                    },
                    password: newPassword
                })


            successCallback && successCallback(resetResponse.data);

        }

        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}

export function updatePassword(authToken, password , successCallback, errorCallback) {
    return async function (dispatch) {
        try {
        
            const response = await axiosNoAuth.post('https://xgfy-czuw-092q.m2.xano.io/api:password-reset/update_password', 
            {
                password,
            },
            {
                headers : {
                    Authorization : `Bearer ${authToken}`
                }
            })
        
            

            successCallback && successCallback(response.data);

        }

        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}

export function sendOtpFromEmail(email, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetPhoneNumberFromEmail, {
                params: {
                    email: email
                }
            })
            console.log(response.data);

            successCallback && successCallback(response.data);


        }
        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err);

        }

    }

}

export function requestOtp(email , phone_number , reset_method, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:password-reset/request', {
                params: {
                    email,
                    phone_number,
                    reset_method

                }
            })
            console.log(response.data);

            successCallback && successCallback(response.data);


        }
        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err);

        }

    }

}


export function sendUTM(page_url, user_id, successCallback, errorCallback) {
    return async function (dispatch) {

        try {
            const response = await axiosAuth.post(API_XANO_UTM_URL, {
                page_url,
                user_id

            })
            console.log(response);
            successCallback && successCallback(response.data);

        }
        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err);

        }
    }

}

export function checkUserAccess(successCallback , errorCallback){
    return async function(dispatch){
        try{
            const response = await axiosAuth(API_XANO_BASE_URL + Api_url.GetUserAccess);

            successCallback && successCallback(response.data);

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);

        }
    }
}

export function setExpirationModal(modal_data, successCallback, errorCallback) {
    return async function (dispatch) {

        try {

            await dispatch({ type: SET_EXPIRATION_TOKEN, payload: modal_data })
            successCallback && successCallback("done")

        }
        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err);

        }
    }
}


export function sendVerificationMessage(verification_method , phone_number , successCallback ,errorCallback){
    return async function (dispatch){
        try{
            const response = await axiosAuth.post(API_XANO_VERIFICATION_BASE_URL + Api_url.SendVerificationMessage,{
                verification_method,
                phone_number
            })

            successCallback && successCallback(response.data);
        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);

        }
    }
}

export function checkOtp(otp,verification_method, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_VERIFICATION_BASE_URL + Api_url.CheckOtp, {
                verification_method,
                otp
            })

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }

}


export function jwtTokenGenerator(data , successCallback , errorCallback){
    return async function(dispatch){
        try{
            const secret = jose.base64url.decode('zH4NRP1HMALxxCFnRZABFA7GOJtzU_gIj02alfL1lvI')
            const jwt = await new jose.EncryptJWT(data)
              .setProtectedHeader({ alg: 'dir', enc: 'A128CBC-HS256' })
              .setIssuedAt()
              .setIssuer('urn:example:issuer')
              .setAudience('urn:example:audience')
              .setExpirationTime('2h')
              .setNotBefore((Date.now() / 1000 )- 180)
              .encrypt(secret)
            
           successCallback &&  successCallback(jwt);
        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}

export function getXanoOneTapToken(jwtToken, successCallback , errorCallback){
    return async function(dispatch){
        try {

            const response = await axiosNoAuth.post(API_XANO_AUTH_SERVICE_BASE_URL + Api_url.AuthService,{
                    signup_type: 'social_google_one_tap',
                    credentials_jwt: jwtToken,
                    signup_medium: 'webapp',
                    campaign : '',
                    is_login : true,
                    signup_page_url : localStorage?.getItem("savedLandingPageURL")
                
            })

            if(response?.data?.result === 'success'){
            dispatch({ type: SET_TOKEN, payload: response.data.authToken })
            

            const profileDetails = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetProfileDetails, {
                headers: {
                    Authorization: `Bearer ${response.data.authToken}`
                }
            })

            dispatch({ type: SET_PROFILE_DETAILS, payload: { ...profileDetails.data } })
            dispatch({ type: SET_USER_ONE_DAY_TIMER , payload : Date.now() + (1*60*60*1000)})


            const userActivity = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetUserActivity, {
                params: {
                    user_id: profileDetails.data.id
                }
            })

            dispatch({ type: SET_USER_ACTIVITY, payload: userActivity.data })

            const challengesMetadata = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetExtendedChallenges, {
                params: {
                    user_id: profileDetails?.data?.id
                }
            })

            // console.log({ challengesMetadata })

            dispatch({ type: SET_USER_EXTENDED_CHALLENGES, payload: challengesMetadata.data })
            successCallback && successCallback(profileDetails.data);
         }
            else{
                successCallback && successCallback({ number_verification : false , show_toast : true , message : response?.data?.message});
            }

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}


export function setUserPassword(authToken , password, successCallback , errorCallback){
    return async function(dispatch){
        try {

            dispatch({ type: SET_TOKEN, payload: authToken })
            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.SetPassword,{
                password      
            })
               
    
                const authData = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetProfileDetails,{
                    headers: {
                        Authorization: `Bearer ${authToken}`
                    }
                })
    
                dispatch({ type: SET_PROFILE_DETAILS, payload: { ...authData.data } })
                dispatch({ type: SET_USER_ONE_DAY_TIMER , payload : Date.now() + (1*60*60*1000)})
    
                const userActivity = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetUserActivity, {
                    params: {
                        user_id: authData.data.id
                    }
                })
    
                dispatch({ type: SET_USER_ACTIVITY, payload: userActivity.data })
                // sendMessage && sendMessage({
                //     XanoToken: authData.data.authToken,
                //     userData: authData.data.profile_details,
                //     userActivity: authData.data.activity
                // })
    
                successCallback && successCallback(authData.data)
    

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function whitelistStatus(email , successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosNoAuth.post('https://xgfy-czuw-092q.m2.xano.io/api:auth-service/authorize-collab/ffe_whitelist', {
                email
            })
            successCallback && successCallback(response?.data)
        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function updateProfileDetails(successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const profileDetails = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetProfileDetails)

            dispatch({ type: SET_PROFILE_DETAILS, payload: { ...profileDetails.data } })
            successCallback && successCallback(profileDetails?.data)
        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}